module.exports = __webpack_public_path__ + "static/media/location_beijing@2x.b6fce01b.png";